<template>
  <div v-if="show" :class="`notification ${type}`">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'NotificationComponent',
  data() {
    return {
      show: false,
      message: '',
      type: 'info', // 'positive','negative', 'error', 'info', 'warning'
    };
  },
  methods: {
    showNotification(newType, newMessage) {
      this.type = newType;
      this.message = newMessage;
      this.show = true

      setTimeout(() => {
        this.show = false
      }, 2500)
    },
  },
};
</script>

<style scoped>
.notification {
  position: fixed;
  top: 10px;
  right: 10px;
  padding: 10px;
  border-radius: 5px;
  color: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  z-index: 12000;
}

.notification.positive,
.notification.success {
  background-color: green;
}

.notification.error,
.notification.negative {
  background-color: red;
}

.notification.info {
  background-color: blue;
}

.notification.warning {
  background-color: orange;
}
</style>
